<script setup lang="ts">
import { transformSlug } from "@/utils/transformSlug";
import { defineProps, defineEmits } from "vue";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  step: any;
};
defineProps<Props>();
type Emits = {
  (
    event: "toggleModalHandler",
    input: any,
    step: any,
    inputIndex?: number,
    groupIndex?: number
  ): void;
};

const emit = defineEmits<Emits>();
const { t } = useTranslate();
</script>

<template>
  <div>
    <h3
      class="text-xl leading-[32px] tracking-[0.01rem] pb-3 text-primary-text-color font-semibold"
    >
      {{ t("phase.input_fields") }}
    </h3>
    <div
      v-for="input in step.inputs.filter((input: any) => (input.type !== 'image' && input.type !== 'repeatable_group' &&  input.type !== 'group' &&  input.type !== 'document' && input.showInMissingInputs && !input.value) 
      || (input.type === 'repeatable_input' && input.value.some((repValue:any)=> !repValue.value)))"
      :key="input.id"
      class="my-3"
    >
      <!-- Non-repeatable inputs -->
      <ul
        v-if="input.type !== 'repeatable_input'"
        class="w-full list-none flex flex-col items-start gap-3"
      >
        <li
          @click="
            emit(
              'toggleModalHandler',
              input,
              step,
              undefined,
              input.repeatableGroupIndex
            )
          "
          class="group hover:cursor-pointer hover:bg-[#F9F8F6] hover:outline hover:outline-[#E3E1EA] p-[3px] hover:rounded-[5px] w-full flex gap-1 items-center outline-1 outline-gray-100 pb-1"
        >
          <p
            class="relative text-base text-primary-text-color font-normal leading-5 tracking-[0.01rem]"
          >
            <span
              v-if="input.parentId !== null"
              class="text-sm font-sans font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
            >
              <span
                v-if="step.inputs.find((i: any) => i.id === input.parentId)?.repeatableGroupDetails"
              >
                {{
                  transformSlug(
                    step.inputs.find((i: any) => i.id === input.parentId)
                      ?.projectReference
                  )
                    ? transformSlug(
                        step.inputs.find((i: any) => i.id === input.parentId)
                          ?.projectReference + ":"
                      )
                    : ""
                }}
                {{
                  step.inputs
                    .find((i: any) => i.id === input.parentId)
                    ?.repeatableGroupDetails.find(
                      (item: any) =>
                        item.order === input.repeatableGroupIndex + 1
                    )?.name
                }}
                /
              </span>
              <span
                v-else-if="step.inputs.find((i: any) => i.id === input.parentId)?.repeatableInputNoun"
              >
                {{
                  step.inputs.find((i: any) => i.id === input.parentId)
                    ?.repeatableInputNoun + ` ${input.repeatableGroupIndex + 1}`
                }}
                /
              </span>
              <span v-else
                >{{
                  step.inputs.find((i: any) => i.id === input.parentId)?.name
                }}
                /</span
              >
            </span>
            {{ input.name }}
          </p>
          <img
            class="w-3 h-3 invisible group-hover:visible ml-auto"
            src="@/assets/pencil-icon.svg"
            alt="Icon"
          />
        </li>
      </ul>
      <ul v-else>
        <li
          v-for="repeatableInput in input.value.filter((item:any)=> !item.value)"
          :key="repeatableInput.index"
          @click="
            emit(
              'toggleModalHandler',
              input,
              step,
              repeatableInput.index,
              input.repeatableGroupIndex
            )
          "
          class="group hover:cursor-pointer hover:bg-[#F9F8F6] hover:outline hover:outline-[#E3E1EA] p-[3px] hover:rounded-[5px] w-full flex gap-1 items-center outline-1 outline-gray-100 pb-1"
        >
          <p
            class="relative text-base text-primary-text-color font-normal leading-5 tracking-[0.01rem]"
          >
            <span
              v-if="input.isConditionallyRepetable"
              class="text-sm font-sans font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
            >
              {{ input.name + ` ${repeatableInput.index + 1}` }}</span
            >

            <span v-else-if="input.repeatableInputNoun">
              <span
                class="text-sm font-sans font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
                >{{ input.name }} /
              </span>
              {{ input.repeatableInputNoun + ` ${repeatableInput.index + 1}` }}
            </span>
            <span
              v-else
              class="text-sm font-sans font-semibold text-[#898790] leading-[17px] tracking-[0.01rem]"
            >
              {{ input.name }}
            </span>
          </p>
          <img
            class="w-3 h-3 invisible group-hover:visible ml-auto"
            src="@/assets/pencil-icon.svg"
            alt="Icon"
          />
        </li>
      </ul>
    </div>
  </div>
</template>
